import React, {useMemo} from "react";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {PermissionEditor} from "../PermissionEditor";
import {BaseAutocomplete} from "../../../../designSystem/components/BaseAutocomplete";
import {BaseInput} from "../../../../designSystem/components/BaseInput";
import {Typography} from "../../../../designSystem/components/Typography";

export const UserEditForm = ({
  editedName,
  editedOrganizations,
  editedRole,
  editedPermissions,
  userRole,
  organizations,
  onChangeEditedName,
  onChangeEditedOrganizations,
  onChangeEditedRole,
  onChangeEditedPermissions,
  handleUpdateUser,
}) => {

  const isValidSubmit = useMemo(() => {
    return (editedName && editedOrganizations?.name && (editedRole || !Object.values(editedPermissions).every(value => value === false)))
  }, [editedName, editedOrganizations, editedRole, editedPermissions])

  return (
    <div className="w-full md:w-[600px] max-w-full flex flex-col gap-4 p-8">
      <Typography variant="title">
        編輯帳號
      </Typography>
      <BaseInput
        label="姓名/名稱"
        value={editedName}
        onChange={(e) => onChangeEditedName(e.target.value)}
      />
      <BaseAutocomplete
        label="業務組別"
        options={organizations}
        value={organizations.find(org => editedOrganizations?.id === org.id) || null} // Find matching organization
        onChangeValue={(value) => {
          onChangeEditedOrganizations(value ? { id: value.id, name: value.name } : null)
        }}
      />
      <PermissionEditor
        permissions={editedPermissions}
        role={editedRole}
        userRole={userRole}
        onChangeRole={onChangeEditedRole}
        onChangePermissions={permissions => onChangeEditedPermissions(permissions)}
      />
      <div className="mt-8">
        <ActionButton
          fullWidth
          label="儲存"
          iconName="fa-save"
          onClick={handleUpdateUser}
          disabled={!isValidSubmit}
        />
      </div>
    </div>
  )
}
